import type { FaireProductEntity } from "../../entity_types/product";

export const p_k6zdrc6vaz: FaireProductEntity = {
  token: "p_k6zdrc6vaz",
  type: "product",
  name: "LM-BG-1004 REUSABLE TOTE -LEOPARD",
  brandToken: "b_h6l667zq",
  brandName: "Girlie Girl Originals",
  imageUrl: "https://cdn.faire.com/fastly/526da3a485abe59a0b545dccc643b804d24c78641e5ad3aa70adc98cfb1518f2.jpeg",
  galleryImageUrls: [],
  priceDollars: 2.5,
  description: "This reusable tote from Girlie Girl Originals features a leopard design and is made for repeated use. It suits errands or casual use and adds a bold touch to daily routines while remaining versatile enough to match many styles.",
  tags: [],
  msrpDollars: 5,
  inStock: true,
  meta: {
    source: "api",
    importedAt: "2026-10-28T21:01:50.573Z",
    importedBy: "entity-db-cli"
  },
  categoryTokens: []
};
